<template>
  <div class="animated fadeIn">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm">
          <div style="height:10px;" />
          <b-button class="excelButton"
                    variant="primary"
                    @click="exportExcel"
                    v-b-tooltip.hover
                    title="Download table content">
            <font-awesome-icon icon="file-excel" />
            Export Excel
          </b-button>
          <ResultTable :dashdata="dashdata" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <Legend />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const ExcelJS = require('exceljs');
  import ResultTable from './ResultTable';

  export default {
    name: 'DashboardPanel',

    components:{
      ResultTable
    },

    props: {
      dashdata: null
    },

    methods: {
      async exportExcel() {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'MSM Loop';
        workbook.lastModifiedBy = 'MSM Loop';
        workbook.created = new Date();
        workbook.modified = new Date();

        const sheet = workbook.addWorksheet('Warenverfügbarkeit');
        sheet.columns = [
          { header: 'Cluster', key: 'cluster', width: 36, filterButton: true  },
          { header: 'Artikel-Nummer', key: 'kpi', width: 12, filterButton: true  },
          { header: 'Welle', key: 'wave-result', width: 24, filterButton: true },
          { header: 'Welle [n]', key: 'wave-number', width: 24, filterButton: true  },
          { header: 'Fehlartikel.', key: 'fehlartikel', width: 48, filterButton: true  }
        ];
        sheet.autoFilter = {
          from: 'A1',
          to: 'E1',
        }

        let column = 0;
        let line = 0;
        const waves = this.dashdata.OverallByWave[0].SurveyWave;

        const header = sheet.getRow(++line);
        header.getCell(++column).value = 'Cluster';
        header.getCell(++column).value = 'Artikel-Nummer';

        for (const wave of [_.first(waves)]) {
          header.getCell(++column).value = `${wave.Name} - Result`;
          header.getCell(++column).value = `${wave.Name} - [n]`;
        }
        header.getCell(++column).value = 'Fehlartikel';
        for (const kpi of this.dashdata.KPI) {
          const grp = sheet.getRow(++line);
          column = 0;
          grp.getCell(++column).value = `${kpi.KpiName}`;
          grp.getCell(++column).value = '';
          for (const wave of kpi.SurveyWave) {
            grp.getCell(++column).value = wave.Result;
            grp.getCell(++column).value = wave.NumberOfShopsTotal;
          }

          let items = _.filter(this.dashdata.list, function(n) { return n.KpiCodeParent == kpi.KpiCode; } );
          for (const item of items) {
            const itm = sheet.getRow(++line);
            column = 0;
            ++column;
            itm.getCell(++column).value = item.KpiName;
            ++column;
            itm.getCell(++column).value = item.KpiFehlartikelAnzahl;
            itm.getCell(++column).value = item.KpiFehlartikel;
          }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        this.download(buffer, "aldi-Warenverfügbarkeit.xlsx", "application/excel");
      },

      download(data, filename, type) {
        var file = new Blob([data], {type: type});
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else { // Others
          var a = document.createElement("a"), url = URL.createObjectURL(file);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
          }, 0);
        }
      }
    },

    computed: {
    }
  }

</script>

<style scoped>

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
}

.row {
  padding: 0px;
}

.col-sm {
  padding-top: 1rem;
}

h3{
  height: 36pt;
  line-height: 28pt;
  text-align: center;
  color: #111111;
  font-size: 16pt;
  font-stretch: extra-condensed;
}

div.leftImage {
  position: absolute;
  left: 3px;
  top: 0px;
  bottom: 1px;
}

.pagbox {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: flex-start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;

  width: 100%;
}

.pagheader {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;

  width: 100%;
}

.pagbox>* {
  flex: 1 1 300px;
  -ms-flex: 0 0 300px;
  /* margin:1px;
  margin: .25em; */
}

.pagheader>* {
  flex: 1 1 150px;
  -ms-flex: 0 0 150px;
  margin:1px;
  /* margin: .5em; */
}

.pagitem{
  min-width: 800px;
  /* max-width: 1200px; */
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagshopsitem{
  min-width: 150px;
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagborder {
  background-color: rgba(255, 255, 255, 0.596);

  margin:0.25em;
  border-style: solid;
  border-width: 1px;
  border-color: #BFBFBF;
  border-radius: 4px;
}

</style>
